import { reactive, ref } from 'vue';
import type { SensitiveViewMode } from '../types';

// --- Actions ---

export type OverviewDispatchAction =
  | { type: 'SET_SENSITIVE_MODE'; payload: SensitiveViewMode }
  | { type: 'RESET_SENSITIVE_MODE' };

// --- Factory ---

export const createOverviewStore = () => {
  const _sensitiveMode = ref<SensitiveViewMode>('presentation');

  const data = reactive({
    sensitiveMode: _sensitiveMode,
  });

  function dispatch(action: OverviewDispatchAction): void {
    if (action.type === 'SET_SENSITIVE_MODE') {
      _sensitiveMode.value = action.payload;
    } else if (action.type === 'RESET_SENSITIVE_MODE') {
      _sensitiveMode.value = 'presentation';
    }
  }

  return { data, sensitiveMode: _sensitiveMode, dispatch };
};
